import { Link } from "react-router-dom";

export default function ProductCard({ product, onQuote, compact = false }) {
  return (
    <article
      className="bg-white border border-[#DFE7E2] rounded-lg overflow-hidden group hover:border-[#AFCDBB] hover:shadow-[0_16px_40px_rgba(7,91,58,0.08)] transition-all flex flex-col"
      data-testid={`product-card-${product.slug}`}
    >
      <Link
        to={`/products/${product.slug}`}
        className={`relative block bg-[#FBFCFB] overflow-hidden ${compact ? "aspect-square" : "aspect-[4/3]"}`}
      >
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-contain p-5 group-hover:scale-[1.04] transition-transform duration-500"
        />

        {product.brand && (
          <span className="absolute top-3 left-3 text-[9px] font-bold uppercase tracking-[0.16em] bg-[#075B3A] text-white px-2.5 py-1.5 rounded-full">
            {product.brand}
          </span>
        )}

        {product.cutResistance && (
          <span className="absolute top-3 right-3 text-[10px] font-bold bg-[#EAF5EF] text-[#075B3A] border border-[#C7E0D1] px-2.5 py-1.5 rounded-full">
            {product.cutResistance}
          </span>
        )}
      </Link>

      <div className={`${compact ? "p-4" : "p-5"} flex-1 flex flex-col text-center`}>
        <h3 className={`font-display font-bold text-[#0F172A] leading-tight ${compact ? "text-base" : "text-lg"}`}>
          {product.name}
        </h3>

        {!compact && (
          <p className="text-sm text-[#66736C] mt-2 line-clamp-2">{product.tagline}</p>
        )}

        <div className="mt-auto pt-4 flex items-center justify-center gap-2 flex-wrap">
          <Link
            to={`/products/${product.slug}`}
            className="inline-flex items-center justify-center border border-[#15935F] text-[#075B3A] hover:bg-[#075B3A] hover:text-white rounded-md px-4 py-2 text-xs font-bold transition-colors"
            data-testid={`product-view-${product.slug}`}
          >
            View Details
          </Link>

          {!compact && onQuote && (
            <button
              type="button"
              onClick={() => onQuote(product)}
              className="inline-flex items-center justify-center bg-[#FF5A00] hover:bg-[#E65100] text-white rounded-md px-4 py-2 text-xs font-bold transition-colors"
              data-testid={`product-quote-${product.slug}`}
            >
              Quote
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
